import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, FileTextIcon, ClockIcon } from 'lucide-react';
export function FinalCTASection() {
  return <section id="precio" className="w-full bg-terracotta py-16 md:py-24 px-4" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center" data-id="element-47">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-6xl font-bold text-cream mb-8" data-id="element-48">
          Este es el Primer Día de Tu Segunda Juventud
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream/10 backdrop-blur-sm p-8 rounded-lg mb-8" data-id="element-49">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-50">
            <span className="text-3xl text-cream/60 line-through" data-id="element-51">$47</span>
            <span className="text-5xl md:text-6xl font-bold text-gold" data-id="element-52">
              $6.39
            </span>
            <span className="text-xl text-cream" data-id="element-53">USD</span>
            <span className="bg-gold text-brown text-sm font-bold px-3 py-1.5 rounded-full" data-id="element-54">
              -86% OFF
            </span>
          </div>

          <motion.a href="https://nuvelalife.com/cart/44812131860550:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-cream text-terracotta px-12 py-5 rounded-lg text-2xl font-bold shadow-xl hover:shadow-2xl transition-shadow mb-6" data-id="element-55">
            ¡Quiero Mi Copia Ahora!
          </motion.a>

          <div className="flex items-center justify-center gap-2 text-gold mb-4" data-id="element-56">
            <ClockIcon className="w-5 h-5" data-id="element-57" />
            <span className="text-sm font-semibold" data-id="element-58">
              Precio especial por tiempo limitado
            </span>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-8" data-id="element-59">
            <div className="flex flex-col items-center gap-2 text-cream" data-id="element-60">
              <DownloadIcon className="w-8 h-8" data-id="element-61" />
              <span className="text-sm" data-id="element-62">Descarga Inmediata</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-cream" data-id="element-63">
              <FileTextIcon className="w-8 h-8" data-id="element-64" />
              <span className="text-sm" data-id="element-65">Formato PDF</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-cream" data-id="element-66">
              <ShieldCheckIcon className="w-8 h-8" data-id="element-67" />
              <span className="text-sm" data-id="element-68">Garantía 30 Días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}